const WAMO_PAGE = {
  HOME: 'https://wamo.io/',
  SIGN_UP: 'https://business.wamo.io/register',
};

export default WAMO_PAGE;
